import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const SummaryContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 4px;
  margin-left: ${(props) => props.marginLeft ?? "0px"};
  margin-right: auto;
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const ButtonData = styled(BaseButton)`
  background: ${(props) => (props?.color ? props.color : "#cccccc")};
  border: ${(props) =>
    props?.color ? "1px solid" + props.color : "1px solid #15aee5"};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  font-weight: normal;
  width: auto;
  padding: 3px 10px;
  font-size: 16px;
  font-family: lato;
`;

export const FlexRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  > div {
    margin-right: 5px;
    margin-bottom: -7px;
  }
`;
